import DocumentoPresolicitud from './DocumentoPresolicitud';
import TipoBeneficioEnum from '@/enums/TipoBeneficioEnum';

export default class RegistroDocumentosPresolicitud {
    constructor(
        public tipoBeneficio?: TipoBeneficioEnum,
        public numeroSolicitud?: number,
        public archivos?: Array<DocumentoPresolicitud>,
        /** Solo aplica para el proceso de registro de fallecimiento */
        public cedulaFallecido?: string
    ) {}
}